package com.dotdrives.web.pages.forms

import react.FC
import react.Props
import react.dom.html.ReactHTML.style

val FormBuilderV2Styles = FC<Props> {
    style { +"""
.forms-v2{--v2-orange:#F26223;--v2-ink:#222D32;--v2-muted:#76848a;display:flex;flex-direction:column;background:#f2f5f6;border:1px solid #E4E8EC;border-radius:9px;overflow:hidden;min-height:690px;height:calc(100dvh - 165px);max-height:1100px;color:var(--v2-ink)}

.forms-v2 *{box-sizing:border-box}
.forms-v2-editor-mount{display:contents}
.forms-v2 [hidden]{display:none!important}
.forms-v2 button{font:inherit;cursor:pointer}
.forms-v2 button:disabled{cursor:default;opacity:.45}
.forms-v2 :is(button,input,textarea,select):focus-visible{outline:2px solid var(--v2-orange);outline-offset:2px}

.forms-v2-toolbar{background:#222D32;color:white;min-height:58px;display:flex;align-items:center;justify-content:space-between;gap:14px;padding:10px 18px;flex-wrap:wrap;flex-shrink:0}
.forms-v2-toolbar-title,.forms-v2-toolbar-actions{display:flex;align-items:center;gap:12px;min-width:0}
.forms-v2-toolbar-title{flex:1}
.forms-v2-back{background:none;border:0;color:#c7d0d4;font-size:12px!important;white-space:nowrap;padding:0}
.forms-v2-toolbar-divider{height:20px;width:1px;background:#526066}
.forms-v2-name{font-size:15px;font-weight:800;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:230px}
.forms-v2-save-state{font-size:11px;color:#aebdc3;white-space:nowrap}
.forms-v2-unsaved{color:#ffb68f}
.forms-v2-readonly{font-size:11px;color:#e0e7e9;white-space:nowrap}
.forms-v2-mode{display:flex;background:#182329;border:1px solid #4a565c;border-radius:6px;padding:3px}
.forms-v2-mode button{background:none;color:#aebdc3;border:0;padding:5px 10px;border-radius:4px;font-size:12px}
.forms-v2-mode button.selected{background:#526168;color:white}
.forms-v2-toolbar-button,.forms-v2-save,.forms-v2-publish{border:1px solid #58656b;border-radius:5px;background:transparent;color:#eaf0f2;padding:8px 11px;font-size:12px!important;font-weight:700!important;white-space:nowrap}
.forms-v2-save{background:#fff;color:#222D32;border-color:white}
.forms-v2-publish{background:var(--v2-orange);border-color:var(--v2-orange);color:white}
.forms-v2-error{padding:8px 16px;background:#fff}
.forms-v2-mobile-nav{display:none}

.forms-v2 .forms-builder-body{display:flex!important;flex-direction:row!important;align-items:stretch;gap:0;min-height:0;flex:1;overflow:hidden}
.forms-v2-editor{width:400px;flex:0 0 400px;background:#fff;border-right:1px solid #E4E8EC;display:flex;flex-direction:column;min-height:0}
.forms-v2 .forms-builder-tabs{display:flex;gap:0;padding:0 20px;margin:0;border-bottom:1px solid #e1e6e8;min-height:48px;flex-shrink:0}
.forms-v2 .forms-builder-tab{flex:1;background:none;border:0;border-bottom:3px solid transparent;border-radius:0;padding:14px 10px 11px;font-size:12px;font-weight:800;color:#819096}
.forms-v2 .forms-builder-tab-active{border-bottom-color:var(--v2-orange);color:var(--v2-orange)}
.forms-v2-editor-scroll{overflow:auto;flex:1;min-height:0;overscroll-behavior:contain}
.forms-v2-tab-content{padding:22px}
.forms-v2-preview-column{min-width:0;flex:1;overflow:auto;background:#EFF1F4}
.forms-v2-section{border-bottom:1px solid #e4e9eb}
.forms-v2-section-heading{display:flex;align-items:center;gap:11px;width:100%;padding:17px 20px;background:white;border:0;text-align:left}
.forms-v2-section-number{display:grid;place-items:center;border:1px solid #dfe5e8;background:#f7f9fa;border-radius:7px;width:27px;height:27px;flex-shrink:0;color:#8b989f;font-size:12px;font-weight:800}
.forms-v2-section-open .forms-v2-section-number{background:#fff1e9;border-color:#ffd4be;color:#e25b21}
.forms-v2-section-label{min-width:0;flex:1;display:flex;flex-direction:column;gap:3px}
.forms-v2-section-title{font-size:13px;font-weight:800}
.forms-v2-section-summary{font-size:10px;line-height:1.4;color:#879399;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.forms-v2-chevron{color:#8d999e;font-size:11px}
.forms-v2-section-open .forms-v2-section-heading{background:#fcfdfd}
.forms-v2-section-body{padding:0 20px 20px;background:#fcfdfd}

.forms-v2 :is(.forms-v2-field,.forms-field-block){display:flex;flex-direction:column;gap:6px;margin:0 0 16px;font-size:11px;font-weight:700;color:#54646c}
.forms-v2-editor :is(input:not([type=color]):not([type=file]),select,textarea){font:inherit;font-size:12px;font-weight:400;color:#34464e;border:1px solid #d8e1e5;background:#fff;border-radius:5px;padding:9px 10px;min-width:0;width:100%;line-height:1.45}
.forms-v2-editor textarea{resize:vertical}
.forms-v2-editor :is(input,select,textarea):disabled{background:#f5f7f8;color:#7c8a90}
.forms-v2-field-heading{display:flex;justify-content:space-between}
.forms-v2-counter{font-weight:400;color:#8d999f;font-size:10px}
.forms-v2-invalid{color:#be442b}
.forms-v2 :is(.forms-v2-help,.forms-field-note){font-size:10px;font-weight:400;line-height:1.65;color:#87949b;margin:5px 0 12px}
.forms-v2-two-columns{display:grid;grid-template-columns:1fr 1fr;gap:12px}
.forms-v2-color{display:flex;align-items:center;gap:7px}
.forms-v2-color input[type=color]{width:34px;height:34px;border:0;padding:0;background:none;flex-shrink:0}
.forms-v2-color input[type=text]{font-family:monospace;font-size:10px}
.forms-v2-contact-note{display:flex;align-items:flex-start;gap:9px;background:#f0f4f6;border:1px solid #e2e9ec;border-radius:6px;padding:10px;margin:0 0 12px;font-size:10px;color:#798990;line-height:1.55}
.forms-v2-field-list{display:flex;flex-direction:column;gap:8px}
.forms-v2-donor-field{border:1px solid #dfe6e9;background:white;border-radius:7px;overflow:hidden}
.forms-v2-donor-field-open{border-color:#f3b28e;box-shadow:0 0 0 2px #fff4ec}
.forms-v2-donor-field-heading{display:flex;align-items:center;gap:8px;padding:11px 10px}
.forms-v2-donor-field-locked{background:#f7f9fa}
.forms-v2-field-lock{font-size:11px;width:18px;text-align:center}
.forms-v2-donor-field-title{display:flex;align-items:center;gap:6px;text-align:left;background:none;border:0;padding:0;min-width:0;flex:1;font-weight:700!important;font-size:12px!important}
.forms-v2-donor-field-title>span:first-child{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.forms-v2-type-pill{border-radius:3px;background:#eef2f4;color:#849298;text-transform:uppercase;font-size:8px;font-weight:600;padding:3px 4px;white-space:nowrap}
.forms-v2-required-note{font-size:8px;color:#9ba7ad;white-space:nowrap}
.forms-v2-field-required{display:flex;gap:5px;align-items:center;font-size:9px;color:#819098}
.forms-v2-donor-field-body{padding:12px;border-top:1px solid #edf0f2}
.forms-v2-field-footer{display:flex;align-items:center;justify-content:space-between;gap:8px}
.forms-v2-field-footer code{font-size:9px;color:#91a0a7;overflow-wrap:anywhere}
.forms-v2-remove,.forms-v2-danger-link,.forms-v2-icon-button{background:none;border:0;color:#bd6755;font-size:10px!important;padding:3px;white-space:nowrap}
.forms-v2-quick-add{display:flex;align-items:center;flex-wrap:wrap;gap:6px;margin-top:14px}
.forms-v2-quick-add>span{font-size:10px;color:#87969d}
.forms-v2-quick-add button{background:white;border:1px dashed #cfdce1;color:#6c828e;padding:5px 8px;border-radius:5px;font-size:10px}
.forms-v2-reorder{display:flex;flex-direction:column;flex-shrink:0;gap:0}
.forms-v2-reorder button{border:0;background:none;color:#84949c;font-size:9px;line-height:12px;padding:0 2px}
.forms-v2-add{border:1px dashed #c7d7df;border-radius:5px;width:100%;background:white;color:#628098;font-size:11px!important;padding:9px;margin:10px 0}
.forms-v2-amount-list{display:flex;flex-direction:column;gap:7px}
.forms-v2-amount-row{display:flex;align-items:center;gap:6px;border:1px solid #e0e7ea;border-radius:6px;padding:7px;background:white}
.forms-v2-amount-default{border-color:#f4c4aa;background:#fffaf7}
.forms-v2-money-input{display:flex;align-items:center;width:90px;flex-shrink:0;color:#8c9ba1;gap:3px}
.forms-v2-money-input input{padding:5px!important;font-weight:700!important}
.forms-v2-amount-label{flex:1;padding:5px!important;font-size:10px!important}
.forms-v2-default-star{color:#bec9ce;border:0;background:none;padding:0;font-size:17px!important}
.forms-v2-default-star[aria-pressed=true]{color:#eeab38}
.forms-v2-amount-row>.forms-v2-remove,.forms-v2-danger-link,.forms-v2-icon-button{font-size:15px!important}
.forms-v2 .forms-toggle-row{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:11px 0;border-bottom:1px solid #edf1f3}
.forms-v2 .forms-toggle-name{font-size:11px;font-weight:700}
.forms-v2 .forms-toggle-sub{font-size:9px;color:#8c9ba1;line-height:1.5;margin-top:3px}
.forms-v2 .forms-switch{position:relative;width:32px;height:19px;padding:0;border:0;border-radius:20px;background:#cbd5da;flex:0 0 32px}
.forms-v2 .forms-switch-knob{position:absolute;top:2px;left:2px;height:15px;width:15px;border-radius:50%;background:white;box-shadow:0 1px 2px #0002;transform:none}
.forms-v2 .forms-switch-on{background:#6b9277}
.forms-v2 .forms-switch-on .forms-switch-knob{left:15px;transform:none}
.forms-v2-match-card{background:white;border:1px solid #dfe7eb;border-radius:6px;padding:12px;margin-bottom:12px}
.forms-v2 .forms-settings-row{border-top:1px solid #e7edef;padding:18px 0;display:flex;align-items:center;gap:12px;justify-content:space-between;margin-top:14px}
.forms-v2 .forms-settings-row-title{font-size:12px;font-weight:700}
.forms-v2 .forms-settings-row-sub{font-size:10px;color:#86969e;line-height:1.6}
.forms-v2 .forms-archive-btn{border:1px solid #eed8d0;background:white;border-radius:5px;color:#b86a55;padding:8px;font-size:10px;white-space:nowrap}
.forms-v2-text-button{color:#627f90;background:none;border:0;padding:0;font-size:11px!important}
.forms-v2 .forms-readonly-url{display:flex;gap:8px;align-items:center;overflow-wrap:anywhere;font-size:10px}
.forms-v2 .forms-readonly-url button{padding:4px 7px;border:1px solid #d8e0e5;background:white;border-radius:4px;font-size:10px}
.forms-v2 .forms-token-row{display:flex;gap:6px;flex-wrap:wrap}
.forms-v2 .forms-token-pill{font-family:monospace;font-size:10px;background:#eef4f7;color:#638095;border-radius:4px;padding:4px 6px}

.forms-v2-feed-rail{width:44px;flex:0 0 44px;background:white;border-left:1px solid #dae3e7;overflow:auto}
.forms-v2-feed-toggle{display:flex;align-items:center;gap:12px;writing-mode:vertical-rl;width:44px;min-height:190px;border:0;background:white;padding:18px 12px;color:#6b8593;font-size:11px!important;font-weight:700!important}
.forms-v2-feed-count{background:#edf3f6;color:#76909f;border-radius:20px;padding:5px;font-size:10px}
.forms-v2-feed-expanded{width:290px;flex-basis:290px}
.forms-v2-feed-expanded .forms-v2-feed-toggle{width:100%;min-height:0;writing-mode:horizontal-tb;padding:14px 18px;border-bottom:1px solid #e6ecef}
.forms-v2 .forms-feed-panel{width:auto;min-width:0;border:0;background:white;padding:0}
.forms-v2 .forms-feed-head{padding:18px 18px 0}
.forms-v2 .forms-feed-title{font-size:13px}
.forms-v2-feed-note{font-size:10px;color:#8b9da6;line-height:1.6;padding:8px 18px}
.forms-v2 .forms-feed-list{padding:0 18px}
.forms-v2 .forms-feed-item{padding:14px 0;border-bottom:1px solid #ecf1f3}
.forms-v2 .forms-feed-item-top,.forms-v2 .forms-feed-item-bottom{display:flex;justify-content:space-between;gap:10px}
.forms-v2 .forms-feed-name{font-size:11px;font-weight:700;overflow:hidden;text-overflow:ellipsis}
.forms-v2 .forms-feed-amount{font-size:12px;font-weight:800;white-space:nowrap}
.forms-v2 .forms-feed-item-bottom{margin-top:5px;font-size:9px;color:#91a2ab}
.forms-v2 .forms-feed-footer{display:flex;justify-content:space-between;padding:14px 18px;font-size:10px;border-top:1px solid #e4ecef}
.forms-v2 .forms-feed-empty{font-size:11px;padding:24px 18px;color:#869aa5}

.forms-v2-mode{border-radius:99px}
.forms-v2-mode button{border-radius:99px;padding:6px 13px}
.forms-v2-toolbar-button,.forms-v2-save,.forms-v2-publish{border-radius:99px;padding:8px 14px}
.forms-v2-save{background:var(--v2-orange);border-color:var(--v2-orange);color:white}
.forms-v2-publish{background:white;color:#222D32;border-color:white}
.forms-v2-section-number,.forms-v2-section-open .forms-v2-section-number{background:#222D32;border-color:#222D32;color:white;border-radius:8px;width:28px;height:28px}
.forms-v2-section-title{font-size:14px}
.forms-v2-section-summary{font-size:11.5px}
.forms-v2 :is(.forms-v2-field,.forms-field-block){font-size:12px}
.forms-v2-editor :is(input:not([type=color]):not([type=file]),select,textarea){font-size:13.5px;border-radius:10px}
.forms-v2 :is(.forms-v2-help,.forms-field-note){font-size:11px}
.forms-v2-contact-note{font-size:11px;border-radius:10px}
.forms-v2-donor-field{border-radius:10px}
.forms-v2-donor-field-title{font-size:13px!important}
.forms-v2-type-pill{font-size:10px;text-transform:none}
.forms-v2-required-note,.forms-v2-field-required{font-size:10.5px}
.forms-v2 .forms-toggle-name{font-size:12px}
.forms-v2 .forms-toggle-sub{font-size:10.5px}
.forms-v2-amount-label{font-size:11px!important}
.forms-v2-field-footer code{font-size:10px}
.forms-v2-quick-add button{font-size:11px;border-radius:99px}
.forms-v2-required-note{max-width:65px;white-space:normal;text-align:right}

@media(max-width:1200px){.forms-v2-name{max-width:150px}
.forms-v2-toolbar{padding:10px 12px}
.forms-v2-toolbar-title,.forms-v2-toolbar-actions{gap:8px}
.forms-v2-feed-expanded{width:250px;flex-basis:250px}
}

@media(max-width:1050px){.forms-v2{height:auto;max-height:none;min-height:650px}
.forms-v2-mobile-nav{display:flex;background:white;border-bottom:1px solid #dce5e9;padding:8px 15px;gap:8px}
.forms-v2-mobile-nav button{flex:1;border:1px solid #dce4e8;color:#758a96;background:white;padding:8px;border-radius:5px;font-size:12px}
.forms-v2-mobile-nav button.selected{background:#fff4ec;border-color:#f4bd9b;color:#da652c}
.forms-v2 .forms-builder-body{flex-wrap:wrap;overflow:visible}
.forms-v2-editor{width:100%;flex-basis:100%;border-right:0}
.forms-v2-editor-scroll{overflow:visible}
.forms-v2-mobile-editor .forms-v2-preview-column,.forms-v2-mobile-preview .forms-v2-editor,.forms-v2-mobile-preview .forms-v2-feed-rail{display:none}
.forms-v2-preview-column{flex-basis:100%;overflow:auto}
.forms-v2-feed-rail,.forms-v2-feed-expanded{width:100%;flex-basis:100%;border-left:0;border-top:1px solid #dce5e9}
.forms-v2-feed-toggle{width:100%;writing-mode:horizontal-tb;min-height:0;padding:13px 18px}
.forms-v2-toolbar-title{flex-basis:100%}
.forms-v2-toolbar-actions{width:100%;flex-wrap:wrap}
.forms-v2-name{max-width:none;flex:1}
.forms-v2-save-state{margin-left:auto}
}

@media(max-width:480px){.forms-v2-toolbar-divider{display:none}
.forms-v2-back{font-size:10px!important}
.forms-v2-name{font-size:12px}
.forms-v2-save-state{font-size:9px}
.forms-v2-toolbar{padding:10px}
.forms-v2-mode button{padding:5px 7px;font-size:11px}
.forms-v2-save,.forms-v2-publish{padding:7px;font-size:10px!important}
.forms-v2-section-heading{padding:15px}
.forms-v2-section-body{padding:0 15px 18px}
.forms-v2-donor-field-heading{gap:5px;padding:10px 8px}
.forms-v2-required-note{font-size:7px}
.forms-v2-two-columns{gap:9px}
}

""" }
}
